import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Button from '../../../UniformComponents/Button'
import Typography from '../../../UniformComponents/Typography'

@observer
class PageBlockHide extends Component {
    close = () => {
        const { store } = this.props
        store.pageBlockToEdit = null
        store.pageBlockHideConfirm = false
    }

    hidePage = () => {
        const { store } = this.props
        const { survey, pageBlockToEdit } = store

        survey.pageBlocks.forEach((pb) => {
            if (pb.id === pageBlockToEdit.id) {
                pb.isHidden = true
            }
        })
        survey.updatePageBlocks(store, survey.pageBlocks)

        this.close()
    }

    modalText = () => {
        const { store } = this.props
        const { survey, pageBlockToEdit } = store
        const pages = survey.pages.filter((p) => pageBlockToEdit.pages.includes(p.id))
        let hasSkipLogic = false

        pages.forEach((p) => {
            if (p) {
                const { hasSkipToPage } = p.getSkipToPage(store)
                hasSkipLogic = hasSkipLogic
                    || hasSkipToPage
                    || p.questions.some((pq) => !!pq.hasSkipLogic(store))
            }
        })
        return i18n.t(`PageBlockHide_${(hasSkipLogic) ? 'skip' : 'no_skip'}`)
    }

    render() {
        const { store } = this.props

        if (!store.pageBlockHideConfirm) return null

        return (
            <Modal
                show={store.pageBlockHideConfirm}
                onClose={this.close}
                style={{ width: '350px' }}
            >
                <div className="pageHide modal-content survey-modal">
                    <Typography type="h3">
                        {i18n.t('gen_confirm_popup_title')}
                    </Typography>

                    <br />

                    <Typography>{this.modalText()}</Typography>

                    <div style={{ marginTop: '15px' }}>
                        <Button
                            className="regular primary"
                            label={i18n.t('gen_yes')}
                            onClick={this.hidePage}
                        />

                        <Button
                            className="regylar tertiary"
                            onClick={this.close}
                            label={i18n.t('gen_no')}
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}

export default PageBlockHide
